angular.module('filters').filter('cents', ["$filter", function($filter) {
  return function(amount, symbol) {
    return $filter('currency')(amount / 100, symbol);
  };
}]);
